import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import tabStyles from '../../shared/ui/tab-switcher/TabSwitcher.module.css';

export function RouteTabSwitcher({ items, ariaLabel = 'Tabs' }) {
  return (
    <nav className={clsx(tabStyles.tabs)} aria-label={ariaLabel}>
      {items.map((item) => (
        <NavLink
          key={item.to}
          className={({ isActive }) => clsx(tabStyles.tab, isActive && tabStyles.tabActive)}
          to={item.to}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
